import { __decorate } from '../_virtual/_tslib.js';
import { injectable } from 'inversify';

let Auth = class Auth {};
Auth = __decorate([injectable()], Auth);

export { Auth };
